import color from '@/core/features/styles/color';

export default function LoopedLoadingBar({
    className,
    style,
    width = 'full-width',
}: {
    className?: string;
    style?: React.CSSProperties;
    width?: 'full-width' | 'w-full';
}) {
    return (
        <div
            className={`progressBar absolute overflow-hidden z-1 ${width} ${width === 'w-full' ? 'left-0' : ''} ${className ?? ''}`}
            style={style}
        >
            <div className={'loopedLoadingBar absolute w-full top-0'} />
            <style jsx>{`
                .progressBar {
                    height: 4px;
                    background-color: ${color('lochmara')};
                }
                :global(.body--desktop) .progressBar {
                    height: 5px;
                }
                .loopedLoadingBar {
                    height: 5px;
                    background: linear-gradient(
                        45deg,
                        ${color('check24Blue')},
                        ${color('azureRadiance')},
                        ${color('dodgerBlue')},
                        ${color('azureRadiance')},
                        ${color('check24Blue')}
                    );
                    background-size: 200% 200%;
                    animation: animateGradient 1.5s infinite;
                }
                @keyframes animateGradient {
                    0% {
                        background-position: 0 50%;
                    }
                    50% {
                        background-position: 100% 50%;
                    }
                    100% {
                        background-position: 0 50%;
                    }
                }
            `}</style>
        </div>
    );
}
